import type { MinigameId } from '../sim/minigames/framework';
import { GallopDrillScene } from './GallopDrillScene';
import { GatesScene } from './GatesScene';
import { PenScene } from './PenScene';
import { RotatingTrainingScene } from './RotatingTrainingScene';
import type { Scene } from './SceneManager';
import { TrailScene } from './TrailScene';
import type { TrainingLaunch, TrainingSceneOptions } from './minigameCommon';

export function createTrainingScene(
  minigame: MinigameId,
  launch: TrainingLaunch,
  options: TrainingSceneOptions,
): Scene {
  switch (minigame) {
    case 'gallop': return new GallopDrillScene(launch, options);
    case 'trail': return new TrailScene(launch, options);
    case 'gates': return new GatesScene(launch, options);
    case 'pen': return new PenScene(launch, options);
    default: return new RotatingTrainingScene(minigame, launch, options);
  }
}
